import { Button, Grid, styled, Typography } from '@mui/material'

import useAuth from 'hooks/useAuth'
import './LoginPage.css'

const CopyRightBox = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  textAlign: 'center',
  '& .MuiTypography-caption': {
    fontSize: '0.68rem',
  },
}))

const Login = () => {
  const auth = useAuth()

  const onSubmit = async () => {
    await auth.login()
  }

  return (
    <div className="login-page flex align-items-center">
      <img className="login-bg" src="/images/webp/login-bg.webp" alt="bg" />
      <div className="login-box">
        <div className="login-head flex align-items-center">
          <div className="logo col-5">
            <img src="/images/ZEE5_For_White_bg.svg" alt="bg" />
          </div>
          <div className="col-7">
            <div className="login-img">
              <img src="/images/animation_body.gif" alt="animation" />
            </div>
          </div>
        </div>
        <div className="login-b">
          <div className="wl-text">Welcome to Pentagon</div>
          <Button
            onClick={onSubmit}
            variant="contained"
            color="primary"
            className="l-adfs-btn"
          >
            Login with ADFS
          </Button>
        </div>
        <CopyRightBox>
          <Typography variant="caption">
            Copyright © {new Date().getFullYear()} Zee Entertainment
            Enterprises Ltd. All rights reserved.
          </Typography>
        </CopyRightBox>
      </div>
    </div>
  )
}

export default Login
